function vidibleOnPlayerReady(player) {
    player.addEventListener(vidible.VIDEO_END, function() {
    	var published_date = $(".vdb_player").data("published");
    	var videovertical = $(".vdb_player").data("videovertical");
    	get_next_video(published_date, videovertical); 
    });
}

